import { MouseEvent, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faEllipsisVertical,
  faFileInvoice,
  faPaperPlane,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Popper from "components/Popper";
import { IBudgetEngagementListItem } from "dto/Budget/IBudgetEngagement";
import styles from "./styles.module.scss";

interface Props {
  row: IBudgetEngagementListItem;
  onDetail: (row: IBudgetEngagementListItem) => void;
  onSettlements: (row: IBudgetEngagementListItem) => void;
  onCorrection: (row: IBudgetEngagementListItem) => void;
  onDelete: (row: IBudgetEngagementListItem) => void;
  /** Wysłanie do procedury akceptacji — dla zaangażowań zwróconych do poprawy / odrzuconych. */
  onSubmit?: (row: IBudgetEngagementListItem) => void;
}

const MenuCell = ({
  row,
  onDetail,
  onSettlements,
  onCorrection,
  onDelete,
  onSubmit,
}: Props) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const status = (row.Status ?? "").toLowerCase();
  // Usuwać można tylko zaangażowania do akceptacji / do poprawy.
  const canDelete = status === "do akceptacji" || status === "do poprawy";
  // Ponowne wysłanie do akceptacji po zwrocie / odrzuceniu (silnik workflow).
  const canSubmit = !!onSubmit && (status === "do poprawy" || status === "odrzucony");

  const run = (action: () => void) => (e: MouseEvent) => {
    e.stopPropagation();
    setOpen(false);
    action();
  };

  return (
    <div className={styles.cell} ref={ref}>
      <div
        className={styles.hover}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>

      <Popper open={open} anchorEl={ref.current} setOpen={setOpen}>
        <div className={styles.dropdown}>
          <div className={styles.dropdownItem} onClick={run(() => onDetail(row))}>
            <FontAwesomeIcon icon={faCircleInfo} />
            Szczegóły
          </div>
          <div
            className={styles.dropdownItem}
            onClick={run(() => onSettlements(row))}
          >
            <FontAwesomeIcon icon={faFileInvoice} />
            Rozliczenia
          </div>
          <div
            className={styles.dropdownItem}
            onClick={run(() => onCorrection(row))}
          >
            <FontAwesomeIcon icon={faPenToSquare} />
            Popraw
          </div>
          {canSubmit && (
            <div
              className={styles.dropdownItem}
              onClick={run(() => onSubmit!(row))}
            >
              <FontAwesomeIcon icon={faPaperPlane} />
              Wyślij do akceptacji
            </div>
          )}
          {canDelete && (
            <div
              className={`${styles.dropdownItem} ${styles.danger}`}
              onClick={run(() => onDelete(row))}
            >
              <FontAwesomeIcon icon={faTrash} />
              Usuń
            </div>
          )}
        </div>
      </Popper>
    </div>
  );
};

export default MenuCell;
